import { exportFileStem, exportMarkdown, parseExport } from '@cerebro-diem/core';
import { supabase } from './supabase';

/** A file handed to the browser to save, under the name given. */
function saveFile(name: string, text: string, type: string) {
  const url = URL.createObjectURL(new Blob([text], { type }));
  const link = document.createElement('a');
  link.href = url;
  link.download = name;
  document.body.append(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

/**
 * "Export my data" (CER-70): everything the signed-in person made, saved as
 * two files named for the day: the complete copy as JSON and a readable copy
 * as Markdown. Nothing is saved unless the package arrived whole. Returns the
 * names saved.
 */
export async function exportMyData(): Promise<string[]> {
  const { data, error } = await supabase.rpc('export_my_data');
  if (error) throw error;
  const exported = parseExport(data);
  const stem = exportFileStem(exported);
  saveFile(`${stem}.json`, `${JSON.stringify(exported, null, 2)}\n`, 'application/json');
  saveFile(`${stem}.md`, exportMarkdown(exported), 'text/markdown');
  return [`${stem}.json`, `${stem}.md`];
}

/**
 * Where a connector reaches this Cerebro Diem: the connector function of the
 * project this site itself talks to. Read from the site's own configuration,
 * so the command Settings shows is right for whichever Cerebro Diem this is.
 */
export function connectorAddress(): string {
  return `${String(import.meta.env.VITE_SUPABASE_URL).replace(/\/+$/, '')}/functions/v1/connector`;
}
